import { HttpInterceptorsConfig } from "./httpInterceptors";
export class FuncionalidadeService extends HttpInterceptorsConfig {
	async listFuncionalidades () {
		const response = await this.axios.get("funcionalidades/listFuncionalidades");
		return response.data;
	}
}
